<template>
  <v-dialog :value="value" @input="$emit('input')" :max-width="isAdmins && pairing.activity && pairing.activity.length ? '700px' : '500px'" persistent>
    <v-card>
      <v-card-title class="title">
        Change Amount for '@{{pairing.userHandle}}'
      </v-card-title>
      <v-card-text class="mt-3 body-2">
        <div>
          <p class="subtitle-1 font-weight-bold">Current Amount : {{utilsFunc.currencySym(pairing.currency)}} {{$options.filters.thousandSeprator(pairing.payoutAmount)}}</p>
        </div>
        <v-alert dense border="left" type="warning" v-if="lockedPayout">
          (You are updating a payout that has been confirmed previously under invoice & brief confirmation tab.)
        </v-alert>
        <div>
          <div class="d-flex">
            <v-combobox
              style="max-width:100px;font-size:18px;margin-right:5px;"
              v-model="updateData.currency"
              :items="currencies"
              outlined
              dense
            ></v-combobox>
            <v-text-field
              dense
              v-model="updateData.amount"
              type="number"
              placeholder="New Amount"
              outlined
              @input="$v.updateData.amount.$touch()"
              :error-messages="$v.updateData.amount.$error && !isAdmins ? `Amount is required.` : ''"
              @blur="$v.updateData.amount.$touch()"
            ></v-text-field>
          </div>
        </div>
        <div v-if="lockedPayout && !isAdmins">
          <v-textarea
            dense
            v-model="updateData.reasons"
            type="text"
            placeholder="Reasons"
            outlined
            @input="$v.updateData.reasons.$touch()"
            :error-messages="$v.updateData.reasons.$error ? `Reasons is required.` : ''"
            @blur="$v.updateData.reasons.$touch()"
          ></v-textarea>
        </div>
        <v-divider />
        <div v-if="isAdmins && pairing.activity && pairing.activity.length">
          <payout-activity-data-table :pairing="pairing" :activityRefresh="activityrefresh" @saved="savedPayoutActivity" />
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn color="red" id="close" text @click.native="close()">Close</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="green" text @click="savePayoutAmount" :disabled="$v.updateData.$invalid">Save</v-btn>
      </v-card-actions>
    </v-card>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="90"
      height.number="90"
    ></loading>
  </v-dialog>
</template>
<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators';
import pairingAPIs from '../../Pairing/pairingAPIs';
import PayoutActivityDataTable from './PayoutActivityDataTable';
import config from '@/config';
import utils from '@/utils'
// import moment from 'moment'
import { mapState } from 'vuex';
import Loading from 'vue-loading-overlay';
export default {
  name: 'PayoutUpdateModal',
  components: {
    Loading,
    PayoutActivityDataTable
  },
  props: {
    value: Boolean,
    lockedPayout: Boolean,
    pairing: Object,
    campaign: Object,
    cappedCOGS: Number,
    currentCOGS: Number
  },
  mixins: [validationMixin],
  validations: function() {
    const validationRules = {
      updateData: {
        amount: { required }
      }
    }
    if (this.lockedPayout && !this.isAdmins) {
      validationRules['updateData']['reasons'] = { required };
    }
    return validationRules
  },
  data () {
    return {
      utilsFunc: utils.func,
      isLoading: false,
      activityrefresh: 0,
      currencies: config.currencies,
      updateData: {
        currency: 'SGD',
        amount: '',
        reasons: ''
      }
    }
  },
  async mounted() {
    await this.$store.dispatch('payment/getCurrencyRates')
  },
  computed: {
    ...mapState({
      savedAmountApproval: state => state.pairing.savedAmountApproval,
      currencyRates: state => state.payment.currencyRates
    }),
    isAdmins: function() {
      return Number(this.$store.state.user.role) === config.userRoles.SUPER_ADMIN_HIGH || Number(this.$store.state.user.role) === config.userRoles.SUPER_ADMIN_LOW
    }
  },
  watch: {
    value: function(newValue) {
      this.updateData = {
        amount: '',
        reasons: ''
      }
      if (newValue) {
        setTimeout(() => {
          this.activityrefresh += 1
        }, 100)
        if (this.pairing.currency) {
          this.updateData.currency = this.pairing.currency
        }
      }
      this.setCurrency()
    },
    campaign: function(newValue) {
      this.setCurrency()
    }
  },
  methods: {
    async savePayoutAmount() {
      if (this.isBudgetOver() && !this.isAdmins) {
        // if budget over and not admin users, show req payout modal
        this.$swal({
          text: 'Your new amount is exceeding the capped COGS, Please continue to request for Approval',
          type: 'warning',
          confirmButtonText: 'Continue',
          showCancelButton: true
        }).then(async (result) => {
          if (result.value) {
            // if budget exceeds, emit to open request amount dialog
            this.close()
            this.$emit('budgetExceeded', this.updateData)
          }
        })
        return
      }
      // proceed to update payout amount
      this.$swal({
        title: 'Are you sure you want to update?',
        type: 'warning',
        confirmButtonText: 'Confirm',
        showCancelButton: true
      }).then(async (result) => {
        if (result.value) {
          if (this.lockedPayout && !this.isAdmins) {
            // if locked payout, update and send get approval email to admins
            this.saveGetApproval()
            return
          }
          // if normal payout update, juz update payout amount
          this.isLoading = true
          let saveData = Object.assign({}, {
            pairingID: this.pairing.pairingID,
            payoutAmount: this.updateData.amount,
            currency: this.updateData.currency
          })
          let resp = await pairingAPIs.updatePayoutAmount(saveData)
          this.isLoading = false
          if (resp) {
            this.$swal({
              text: 'Payout Updated.',
              type: 'success'
            })
            this.close()
            setTimeout(() => {
              this.$emit('refreshPairing')
            }, 100)
          } else {
            this.$swal({
              text: 'Error Updating Amount!',
              type: 'error'
            })
          }
        }
      })
    },
    async saveGetApproval() {
      this.isLoading = true
      let saveData = Object.assign({}, {
        pairingID: this.pairing.pairingID,
        amount: this.updateData.amount,
        reasons: this.updateData.reasons,
        currency: this.updateData.currency
      })
      await this.$store.dispatch('pairing/saveAmountApproval', saveData)
      this.isLoading = false
      if (this.savedAmountApproval) {
        this.$swal({
          text: 'Payout Approval Sent.',
          type: 'success'
        })
        this.close()
        setTimeout(() => {
          this.$emit('refreshPairing')
        }, 100)
      } else {
        this.$swal({
          text: 'Error Updating Amount!',
          type: 'error'
        })
      }
    },
    isBudgetOver() {
      // check current edit amount with target budget
      let currencyAmt = 0
      let updateAmt = 0
      if (this.updateData.currency !== 'SGD') {
        updateAmt = utils.func.convertCurrency(this.updateData.currency, this.updateData.amount, this.currencyRates)
      }
      if (this.pairing.currency !== 'SGD') {
        currencyAmt = utils.func.convertCurrency(this.pairing.currency, this.pairing.payoutAmount, this.currencyRates)
      } else {
        currencyAmt = this.pairing.payoutAmount
      }
      let currentBudget = (this.currentCOGS - Number(currencyAmt)) + Number(updateAmt)
      return currentBudget / Number(this.cappedCOGS) > 1;
    },
    savedPayoutActivity() {
      this.close()
      setTimeout(() => {
        this.$emit('refreshPairing')
      }, 100)
    },
    close() {
      this.$emit('input')
    },
    setCurrency() {
      if (!this.campaign || this.pairing.payoutAmount) return
      const currencyOptions = [
        { text: 'SG', value: 'SGD' },
        { text: 'ID', value: 'IDR' },
        { text: 'PH', value: 'PHP' },
        { text: 'TH', value: 'THB' },
        { text: 'MY', value: 'MYR' },
        { text: 'VN', value: 'VND' }
      ]
      const targetLocation = Array.isArray(this.campaign.targetLocation)
        ? this.campaign.targetLocation[0]
        : this.campaign.targetLocation
      const selectedCurrency = currencyOptions.find((option) => option.text === targetLocation)
      if (selectedCurrency) {
        this.updateData.currency = selectedCurrency.value
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// PayoutUpdateModal.vue?5cf0949f